import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Box, Button, Container, Flex } from "@chakra-ui/react";
import { UserSelectCombobox } from "./UserSelectCombobox.tsx";
import { useCurrentProjectId } from "../../stores/currentProjectId.store.ts";
import { toTitleCase } from "../../../Project/utils/toTitleCase.ts";

export const ActualAdminPanel = () => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["contactEmails"],
    queryFn: async () => {
      const contacts = await axios.get(
        "https://n8n.thelightgroupusa.com/webhook/admin/user/emails",
      );
      return contacts?.data.filter((x) => !!x.Email) ?? [];
    },
  });

  const projectId = useCurrentProjectId();

  if (isLoading || error) return <></>;

  return (
    <Box w={"100%"} bg={"orange.500"}>
      <Container>
        <Flex justify={"space-between"} w={"100%"}>
          <UserSelectCombobox
            users={data.map((x) => ({
              label:
                toTitleCase(`${x.First_Name} ${x.Last_Name}`) + " - " + x.Email,
              value: x.Email,
            }))}
          />
          <a
            style={{ display: projectId ? "inline-block" : "none" }}
            target="_blank"
            href={`https://crm.zoho.com/crm/org883892202/tab/Potentials/${projectId}`}
          >
            <Button>Open in Zoho</Button>
          </a>
        </Flex>
      </Container>
    </Box>
  );
};
